/* eslint-disable react/button-has-type */
import React from 'react'
import * as s from './Modal.module.scss'

const Modal = ({ modalChildren, onClose }) => {
  return (
    <div className={s.modalContainer}>
      <div className={s.modal}>
        <button onClick={onClose} className={s.closeBtn}>
          X
        </button>
        {modalChildren}
      </div>
    </div>
  )
}

export default Modal
